var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[(_vm.getLang==='hk')?_c('PersonalInfoCollectionStatementHk'):_vm._e(),(_vm.getLang==='sg')?_c('PersonalInfoCollectionStatementSg'):_vm._e(),(_vm.getLang==='th')?_c('PersonalInfoCollectionStatementTh'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }